import CellLink from '@/components/GokuDataGrid/CellLink'
import { formatCurrency } from '@/utils/function'
import { generatePathDatacentral, paths } from '@/utils/path'
import { GridColDef } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'
import { SalesTarget } from '../../../types'

export const targetsColumns = (t: TFunction): GridColDef<SalesTarget>[] => [
    {
        field: 'employee_name',
        headerName: t('employee'),
        width: 200,
        renderCell: (params) => (
            <CellLink
                to={generatePathDatacentral(paths.employeeUpdate, {
                    id: params.row.employee_id,
                })}
            >
                {params.row.employee_name}
            </CellLink>
        ),
    },
    {
        field: 'target_scope',
        headerName: t('scope'),
        width: 100,
        valueGetter: (value) => {
            const scopeMap: Record<string, string> = {
                month: t('month'),
                quarter: t('quarter'),
                year: t('year'),
            }
            return scopeMap[value] || value
        },
    },
    {
        field: 'target_year',
        headerName: t('year'),
        width: 100,
    },
    {
        field: 'target_month',
        headerName: t('month'),
        width: 100,
        valueGetter: (value) => (value ? `${t('month')} ${value}` : '-'),
    },
    {
        field: 'target_quarter',
        headerName: t('quarter'),
        width: 100,
        valueGetter: (value) => (value ? `${t('quarter')} ${value}` : '-'),
    },
    {
        field: 'product_group_name',
        headerName: t('product_group'),
        width: 150,
        valueGetter: (value) => value || t('all'),
    },
    {
        field: 'target_amount',
        headerName: t('target_amount'),
        width: 180,
        type: 'number',
        valueFormatter: (value) => formatCurrency(value),
    },
    {
        field: 'notes',
        headerName: t('notes'),
        width: 200,
        valueGetter: (value) => value || '-',
    },
    {
        field: 'is_active',
        headerName: t('status'),
        width: 100,
        renderCell: (params) => (
            <span
                className={`px-2 py-1 rounded text-xs ${
                    params.value
                        ? 'bg-green-100 text-green-800'
                        : 'bg-gray-100 text-gray-800'
                }`}
            >
                {params.value ? t('active') : t('inactive')}
            </span>
        ),
    },
]
